import React from "react";
import styles from "./NotifactionMobile.module.css";
import NotificationItemMobile from "./notificationItemMobile/NotificationItemMobile";
import {
  messagesMobileItems,
  notificationsMobileItems,
} from "./NotifactionMobileAPI";
import { useLocation } from "react-router-dom";

export function NotifactionMobile() {
  const location = useLocation();
  const isNotification = location.state ? location.state.isNotification : false;
  if (isNotification) {
    return (
      <div className={styles.notification_ui_dd} aria-labelledby="navbarDropdown">
        <div className={styles.notification_ui_dd_header}>
          <h3>Notification</h3>
        </div>
        <div className={styles.notification_ui_dd_content}>
          {notificationsMobileItems.map((item, index) => {
            return (
              <NotificationItemMobile
                key={index}
                isNotification={true}
                item={item}
              />
            );
          })}
        </div>
        <div className={styles.notification_ui_dd_footer}>
          <a href="#!" className={styles.btn_more_result}>
            Show more
          </a>
        </div>
      </div>
    );
  } else {
    return (
      <div className={styles.notification_ui_dd} aria-labelledby="navbarDropdown">
        <div className={styles.notification_ui_dd_header}>
          <h3>Message</h3>
        </div>
        <div className={styles.notification_ui_dd_content}>
          {messagesMobileItems.map((item, index) => {
            return (
              <NotificationItemMobile
                key={index}
                isNotification={false}
                item={item}
              />
            );
          })}
        </div>
        <div className={styles.notification_ui_dd_footer}>
          <a href="#!" className={styles.btn_more_result}>
            Show more
          </a>
        </div>
      </div>
    );
  }
}

export default NotifactionMobile;
